import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import ReviewContainer from '../containers/EditorContainer/WorkspaceContainer/ReviewContainer';
import { hideModal } from '../ducks/modals';
import AddToCartConfirmProject from './AddToCartConfirmProject';
import CompleteProject from './CompleteProject';
import StepModal from './StepModal';
import PicabooConstants from '../common/PicabooConstants';
import { logCustomEvent } from '../utils/TagManager';
import { pricingSelector } from '../reducers/selectors';

const AddToCartModal = ({ show, pricing }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  let [currentStep, setCurrentStep] = useState(1);
  const [useLogo, setUseLogo] = useState(PicabooConstants.LOGO_UPGRADE.NONE);
  const nextDisabled = useMemo(() => pricing && pricing.error, [pricing]);
  const backDisabled = useMemo(() => currentStep === 1, [currentStep]);
  const goBack = useCallback(() => {
    if (backDisabled) return;
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  }, [backDisabled]);
  const close = useCallback(() => {
    dispatch(hideModal());
  }, [dispatch]);
  const steps = useMemo(
    () => [
      {
        title: t('ADDTOCARTSTEPS.Sign In/Register'),
        content: null,
      },
      {
        title: t('ADDTOCARTSTEPS.Confirm Project'),
        content: (
          <AddToCartConfirmProject setUseLogo={setUseLogo} useLogo={useLogo} />
        ),
      },
      {
        title: t('ADDTOCARTSTEPS.Review Project'),
        content: <ReviewContainer dispatch={dispatch} />,
      },
      {
        title: t('ADDTOCARTSTEPS.Complete Project'),
        content: <CompleteProject close={close} useLogo={useLogo} />,
      },
    ],
    [setUseLogo, useLogo, close, dispatch],
  );
  const goForward = useCallback(() => {
    setCurrentStep((prev) => prev + 1);
  }, []);

  useEffect(() => {
    if (
      steps[currentStep] ===
      steps.find((s) => s.title === t('ADDTOCARTSTEPS.Review Project'))
    ) {
      logCustomEvent('confirm_project_logo', { logo: useLogo });
    } else if (
      steps[currentStep] ===
      steps.find((s) => s.title === t('ADDTOCARTSTEPS.Complete Project'))
    ) {
      logCustomEvent('review_project');
    }
  }, [steps, currentStep, t, useLogo]);

  return (
    <StepModal
      nextStepHandler={goForward}
      previousStepHandler={goBack}
      backDisabled={backDisabled}
      nextDisabled={nextDisabled}
      close={close}
      show={show}
      setUseLogo={setUseLogo}
      useLogo={useLogo}
      steps={steps}
      currentStep={currentStep}
    />
  );
};

export default connect((state) => ({
  pricing: pricingSelector(state),
}))(AddToCartModal);
